import { createListSelector } from 'redux/utils'

export const selectCollectionData = createListSelector('Collection')
